<template>
  <!-- TODO: Replace headerButtons with a button bar component that takes md-buttons as a child (maybe in the future when md-components is a considered project?) -->
  <md-report-layout :header-buttons="headerButtons"
                    :loading="loading"
                    :loading-text="loadingText"
                    ref="reportLayout">

    <template v-slot:header-left>
      <md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged" display-mode="header"/>
    </template>

    <template v-slot:employee-list>
      <!--md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged"/-->

      <EmployeeList :loading="loadingEmployees"
                        :employees="employees"
                        :can-select-multiple="true"
                        :init-all-selected="true"
                        @employeeSelected="onEmployeeSelected"
                        style="height: calc(100vh - 400px); margin-bottom: 10px;"/>

      <div class="header" style="font-size: 13px; padding-left: 5px; font-weight:bold; margin-bottom: 10px; text-align: left">
        {{ $t('report.comp.employeesSelected', [countSelectedEmployees, countEmployees]) }}
      </div>

      <div class="header" style="display:flex; flex-direction: row; justify-content: flex-start;">
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="selectAllEmployees"
                  style="border-radius: 0; margin-right: 0.5rem;">
          {{ $t('report.comp.selectAll') }}
        </b-button>
        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="deselectAllEmployees"
                  style="border-radius: 0; margin-right: 1rem; justify-self: flex-start;">
          {{ $t('report.comp.deselectAll') }}
        </b-button>

        <b-button size="sm"
                  variant="outline-secondary"
                  v-on:click="toggleShowOnlyActiveEmployees"
                  style="border-radius: 0; margin-left: auto;">
          {{ showOnlyActiveEmployees
            ? $t('report.comp.showAllEmployees')
            : $t('report.comp.showOnlyActiveEmployees')
            }}
        </b-button>
      </div>
    </template>

    <template v-slot:report-settings>
      <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange"/>
    </template>

    <template v-slot:report-list>
      <ml-report-list :reports="reports"
                      :loading="loadingReports"
                      @deleteReport="openDeleteReportPopup"
                      @downloadReport="downloadReport"
                      @reportClicked="openReport"/>
    </template>

    <template v-slot:button-bar v-if="creatingReport || !canCreateReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
         {{ $t('report.comp.reportBeingCreated') }}
      </span>
      <span v-else-if="!employmentModelsSelected || !wageTypesSelected">
        {{ $t('report.view.selectEmploymentAndWageTypes') }}
      </span>
      <span v-else>
        {{ $t('report.comp.selectAtLeastOneEmployee') }}
      </span>
    </template>

  </md-report-layout>
</template>

<script>
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import MlReportList from '@/components/uicomponents/ml-report-list';
import ReportConfig from '@/components/uicomponents/reportconfig';
import EmployeeList from '@/components/uicomponents/employeelist';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import { mapGetters } from "vuex";
import VueEventBus from '../../vue-event-bus';

export default {
  name: 'reportoverviewvariable',
  components: {
    MdReportLayout,
    MdDateSelect,
    MlReportList,
    ReportConfig,
    EmployeeList
  },
  mixins: [ reportMixin ],
  data() {
    return {
      reportType: 'INDIVIDUALWAGETYPES',
      loadingText: this.$t('report.view.variableOverviewLoading'),

      models: [],
      wageTypes: [],
      contracts: [],
    }
  },
  created: function () {
    // console.log("CREATED");
    VueEventBus.$on("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobReportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    // console.log("BEFORE DESTROY");
    VueEventBus.$off("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$off("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$off("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$off("JobReportEvent:jobFailed", this.jobFailed);
  },
  destroyed: function () {
    // console.log("DESTROYED");
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.companyId !== undefined) {

      this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId','companySettings', 'storesSettings','employeeContractMap']),
    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
            tooltip: this.$t('report.view.variableOverview'),
            title: this.$t('report.view.variableOverview'),
            helperText: this.$t('report.view.variableOverviewHelp')
            //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport || !this.canCreateReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReportProxy();
          },
          show: true,
          tooltip: this.$t('report.comp.createReport'),
          title: this.$t('report.comp.createReport'),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

        state.helperLinks = [
            {
                title: this.$t('report.view.individualWageTypesTitle'),
                helperText: this.$t('report.view.individualWageTypesHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3130720268",
                externalLabel: this.$t('export.builder.learnMore'),
                cancelLabel: this.$t('export.builder.thanks'),
                icon: "fa-file-export"
            },
            {
                title: this.$t('report.view.reportViaMDPTitle'),
                helperText: this.$t('report.view.reportViaMDPHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3262611460",
                externalLabel: this.$t('export.builder.learnMore'),
                cancelLabel: this.$t('export.builder.thanks'),
                icon: "fa-file-signature"
            },
            {
                icon: "fa-video",
                title: this.$t('report.view.watchTrainingVideoTitle'),
                helperText: this.$t('report.view.watchTrainingVideoHelp'),
                externalUrl: "https://www.youtube.com/watch_popup?v=BePh4xNJvsY",
                externalLabel: this.$t('report.view.basicTrainingReports'),
                cancelLabel: this.$t('global.ui.close')
            },
            {
                title: this.$t('report.view.getSupportTitle'),
                helperText: this.$t('report.view.getSupportHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
                externalLabel: this.$t('export.comp.contactSupport'),
                cancelLabel: this.$t('global.ui.close')
            }
        ];
      return state;
    },

    canCreateReport() {
      return this.employmentModelsSelected && this.wageTypesSelected && this.employeesSelected;
    },
    employmentModelsSelected() {
      const employmentModels = this.reportConfig.employmentModels || {};
      return (employmentModels.selectedModels || []).length > 0;
    },
    wageTypesSelected() {
      const wageTypes = this.reportConfig.wageTypes || {};
      return (wageTypes.selectedWageTypes || []).length > 0;
    },
    employeesSelected() {
      return this.countSelectedEmployees > 0;
    }
  },
  watch: {
    companyId(newVal, oldVal) {
      console.log("COMPANY ID CHANGED", newVal, oldVal);
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data (BUSINESS) logic. (https://en.wikipedia.org/wiki/Business_logic)
  methods: {
    getReportName() {
        return this.rangeMode === 'monthlyRange'
            ? `${ this.$t('report.comp.overviewVariable') }, ${ moment(this.rangeStart).format('MMMM YYYY') }`
            : `${ this.$t('report.comp.overviewVariable') }, ${ moment(this.rangeStart).format('DD.MM.YYYY') } ${ this.$t('export.builder.to') } ${ moment(this.rangeEnd).format('DD.MM.YYYY') }`;
    },

    async refresh(force = false) {
      this.loading = true;
      this.updateReportConfig('reportname', this.getReportName());

      try {
        await Promise.all([
          this.$helpers.GetCompanySettings(force),
          this.$helpers.GetStoresSettings(force),
          this.$helpers.GetExportSettingsMap(force),
          this.$helpers.GetEmployeeContractMap(force),
          this.getEmployeeContracts(),
          this.loadModels(),
          this.loadWageTypes(),
          this.loadReports(this.reportType),
          this.loadEmployees(true),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();

        // console.log(this.getReportConfigValue('reportname'));
        // reportConfig can be loaded after generating the options, as reportConfig does not overwrite the options
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());

        console.log(this.reports);

        this.loading = false;
      }
    },

    generateReportConfigOpts() {
      let view = this;
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.comp.documentName'), true, disabled, 'nameSection');
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.comp.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('employee.contract.comment'), false, disabled, 'commentSection');
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.comp.enterComment'));

      const formatSection = this.createReportConfigSection(this.$t('report.comp.fileFormat'), false, disabled, 'formatSection');
      this.addSelectConfigOption(formatSection, 'fileformat', [
        this.addSelectableValue('PDF', 'pdf', true),
        // this.addSelectableValue('CSV', 'csv'),
      ]);


      // console.log(...this.storesSettings.data.map(store => this.addSelectableValue(store.name, store.id)));
      const storeSection = this.createReportConfigSection('Store', false, disabled, 'storeSection');
      this.addSelectConfigOption(storeSection, 'storeId', [
        ...this.storesSettings.data.map(store => this.addSelectableValue(store.name, store.id))
      ]);

      const contentSection = this.createReportConfigSection(this.$t('report.comp.documentContent'), false, disabled, 'contentSection');
      view.addSelectConfigOption(contentSection, 'employeeSelection', [
          view.addSelectableValue(view.$t('report.view.allEmployees'), 1, true),
          view.addSelectableValue(view.$t('report.view.onlyEmployeesWithValues'), 3),
      ]);
      view.addSelectConfigOption(contentSection, 'shiftSelection', [
          view.addSelectableValue(view.$t('report.view.allShifts'), 1),
          view.addSelectableValue(view.$t('report.view.onlyActualShifts'), 2, true),
          view.addSelectableValue(view.$t('report.view.onlyPlannedShifts'), 3),
      ]);
      view.addSelectConfigOption(contentSection, 'showOnlySums', [
          view.addSelectableValue(view.$t('report.view.showAllValues'), false, true),
          view.addSelectableValue(view.$t('report.view.showOnlySums'), true),
      ]);
      view.addSelectConfigOption(contentSection, 'sums', [
          view.addSelectableValue(
              view.$t('report.view.allSums'),
              [
                  view.addSelectableValue(view.$t('report.view.employeeSums'), 'employeeSums', true),
                  view.addSelectableValue(view.$t('report.view.employmentModelSums'), 'employmentModelSums', true),
                  view.addSelectableValue(view.$t('report.view.wageTypeSums'), 'wageTypeSums', true),
                  view.addSelectableValue(view.$t('report.view.totalSums'), 'totalSums', true),
              ],
              ['employeeSums', 'employmentModelSums', 'wageTypeSums', 'totalSums'],
              'selectedSums'
          )
      ], true);
      view.addSelectConfigOption(contentSection, 'employmentModels', [
          view.addSelectableValue(
              view.$t('report.view.allEmploymentGroups'),
              view.models.map(model => view.addSelectableValue(model.name, model.id)),
              view.models.map(model => model.id),
              'selectedModels'
          )
      ], true);
      view.addSelectConfigOption(contentSection, 'wageTypes', [
          view.addSelectableValue(
              view.$t('report.view.allWageTypes'),
              view.wageTypes.map(wageType => view.addSelectableValue(wageType.name, wageType.id)),
              view.wageTypes.map(wageType => wageType.id),
              'selectedWageTypes'
          )
      ], true);
      const groupSection = this.createReportConfigSection(this.$t('report.comp.grouping'), false, specialDisabled, 'groupSection');
      this.addSelectConfigOption(groupSection, 'groupBy', [
          this.addSelectableValue(this.$t('report.view.noEmployeeGrouping'), 0, true),
          this.addSelectableValue(this.$t('report.view.groupEmployeesByModel'), 1),
      ]);
      const sortSection = this.createReportConfigSection(this.$t('report.comp.sorting'), false, specialDisabled, 'sortSection');
      this.addSelectConfigOption(sortSection, 'sortEmployeesBy', [
          this.addSelectableValue(this.$t('report.view.sortEmployeesByLastname'), 0, true),
          this.addSelectableValue(this.$t('report.view.sortEmployeesByPersonnelNumber'), 1),
      ]);
      this.addSelectConfigOption(sortSection, 'sortEntriesBy', [
          this.addSelectableValue(this.$t('report.view.sortEntriesByEarnCode'), 0, true),
          this.addSelectableValue(this.$t('report.view.sortEntriesByDate'), 1),
      ]);
      this.addSelectConfigOption(sortSection, 'showSumsAtTop', [
          this.addSelectableValue(this.$t('report.view.sumsAtDocumentEnd'), 0, true),
          this.addSelectableValue(this.$t('report.view.sumsAtDocumentStart'), 1),
      ]);

      const localeSection = this.createReportConfigSection(this.$t('report.comp.locale'), false, disabled, 'localeSection');
      this.addLanguageSelectConfigOption(localeSection, 'settingLocale', disabled);

      const headerFormatSection = this.createReportConfigSection(  this.$t('report.comp.header'), false, specialDisabled, 'headerFormatSection');
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);

    },

    async createReportProxy() {
      if (this.rangeMode === 'customRange') {

        if (this.rangeStart.month() != this.rangeEnd.month() || this.rangeStart.year() != this.rangeEnd.year()) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startEndSameMonth'));
          return;
        }
        if (this.rangeStart > this.rangeEnd) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startBeforeEnd'));
          return;
        }

      }
      await this.generateReport();
    },


    getEmployeeContracts: function () {
      let view = this;
      let url = '/api/sec/proxy/md/employee/contracts';

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/proxy/md/employee/contracts');

      return this.axios({
        method: 'get',
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then(resp => {
        return view.$helpers.GetStores()
          .then(storeResponse => {
            let storeIds = storeResponse.map(s => s.id);
            view.contracts = {};
            Object.values(resp.data).forEach(contract => {
              if (storeIds.includes(contract.storeId)) {
                if (view.contracts.hasOwnProperty(contract.remoteId)) {
                  view.contracts[contract.remoteId].push(contract);
                } else {
                  view.contracts[contract.remoteId] = [];
                  view.contracts[contract.remoteId].push(contract);
                }
              }
            });
            // console.log(view.contracts);
          });
      }).catch(error => {
        console.log(error);
      });
    },


    async generateReport() {
      this.creatingReport = true;

      const employeeIds = this.selectedEmployeeIds;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const hourFormats = {
        '3': '3',
        '2': '2',
        'Hm': 'Hm',
      };
      const hourFormat = hourFormats[this.reportConfig.settingHourFormat] || 'Hm';

      let locale = this.reportConfig.settingLocale || 'de';
      if (locale === 'current') {
        locale = this.$i18n.locale;
      }

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'year': this.rangeStart.year(),
        'month': this.rangeStart.month() + 1,
        'headerDateFormat': dateFormat,
        'hourFormat': hourFormat,
        'storeIds': [this.reportConfig.storeId],
        'options': {
          'employmentModelsBool': JSON.stringify(this.models.map(model => model.id).sort()) === JSON.stringify(this.reportConfig.employmentModels.selectedModels.sort()),
          'employmentModels': this.reportConfig.employmentModels.selectedModels,
          'wageTypesBool': JSON.stringify(this.wageTypes.map(wageType => wageType.id).sort()) === JSON.stringify(this.reportConfig.wageTypes.selectedWageTypes.sort()),
          'wageTypes': this.reportConfig.wageTypes.selectedWageTypes,
          'employeeSelection': this.reportConfig.employeeSelection,
          'shiftSelection': this.reportConfig.shiftSelection,
          'showOnlySums': this.reportConfig.showOnlySums,
          'employeeSums': this.reportConfig.sums.selectedSums.includes('employeeSums'),
          'employmentModelSums': this.reportConfig.sums.selectedSums.includes('employmentModelSums'),
          'wageTypeSums': this.reportConfig.sums.selectedSums.includes('wageTypeSums'),
          'totalSums': this.reportConfig.sums.selectedSums.includes('totalSums'),
          'groupBy': this.reportConfig.groupBy,
          'sortEmployeesBy': this.reportConfig.sortEmployeesBy,
          'sortEntriesBy': this.reportConfig.sortEntriesBy,
          'showSumsAtTop': this.reportConfig.showSumsAtTop
        },
        'headerLogo': 'ml',
        'documentComment': comment ?? "",
        'fileformat': this.reportConfig.fileformat ?? 'pdf',
        'language': locale,
      };

      if (this.rangeMode === 'customRange') {


        config.fromDate = this.rangeStart.format();
        config.toDate = this.rangeEnd.format();

      }

      // console.log(employeeIds);
      // console.log(config);

      await this.createReport(this.reportType, name, comment ? comment : "", config);
    },
    jobCreated: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 50);
    },
    jobStarted: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 100);
    },
    jobEnded: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    jobFailed: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    reloadDocuments: function () {
      this.loadReports(this.reportType);
    },



    loadModels: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };
      return view.$helpers
      .GetCall("/api/sec/employmentModels", params)
      .then((response) => {
        let data = response.data.data;
        let tmp = [];
        for (let i = 0; i < data.length; i++) {
          let item = {
            id: data[i].id,
            number: data[i].number,
            name: data[i].name,
            isDefault: data[i].isDefault,
          };
          tmp.push(item);
        }
        view.models = tmp.slice();
        console.log("models", view.models);
      })
      .catch((e) => {
        console.log(e);
      });
    },
    loadWageTypes: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };
      return view.$helpers
      .GetCall("/api/sec/individualWageTypes", params)
      .then((response) => {
        let data = response.data.data;
        let tmp = [];
        for (let i = 0; i < data.length; i++) {
          let item = {
            id: data[i].id,
            numberString: data[i].numberString,
            name: data[i].name,
            details: data[i].details,
          };
          tmp.push(item);
        }
        view.wageTypes = tmp.slice();
        console.log("wagetypes", view.wageTypes);
      })
      .catch((e) => {
        console.log(e);
      });
    },

  },
}
</script>

<style scoped>
/* remove max-height from sub component: 100vh would cut off the list of employmentmodels and wagetypes when the list is too long */
>>>.config-entry>.body.entry-expanded {
  max-height: 100% !important;
}
</style>
